import React, { Component } from 'react';
import './Status.css'

class Status extends React.Component {
  status = ""

  updateStatus(newStatus) {
    this.status = newStatus;
  }

  constructor(props) {
    super(props);

    if (this.props.status === "offline") {
      this.status = 'OFFLINE';
    } else if(this.props.status === "online") {
      this.status = 'ONLINE';
    } else {
      this.status = 'CHECKING';
    }
  }

  render() {
    return <span className={this.props.status}>{this.status}</span>
  }
}

export default Status;


// WEBPACK FOOTER //
// ./src/Components/Status.js